import { createAction, props } from '@ngrx/store';
import { BUNDLE } from '../bundle.constants';
import { BundleReviewModel } from '@lms/shared/models';

export const getBundleReviews = createAction(`[${BUNDLE.featureName}] Get Bundle Reviews`, props<{ bundleUrl: string }>());
export const setBundleReviews = createAction(`[${BUNDLE.featureName}] Set Bundle Reviews`, props<{ reviews: BundleReviewModel[] }>());
